class FilterControl extends HTMLButtonElement {
  constructor() {
    super();
    this.filterId = this.dataset.filterId
    this.bindEvent();
  }

  bindEvent() {
    this.addEventListener('click', (e) => {
      const tagFilter = document.querySelector(`tag-filter[id=${this.filterId}]`);
      if (this.type === 'submit') {
        tagFilter.commit();
      } else {
        tagFilter.reset();
      }
    })
  }
}
if (!window.customElements.get("filter-control")) {
  window.customElements.define("filter-control", FilterControl, {
    extends: "button",
  });
}
